import React from "react";
import styles from "./locale-nav.module.scss";
import useLocales from "./useLocales";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import arrow from "svgs/arrow.svg";

const colors = ["var(--red)", "var(--yellow)", "var(--green)", "var(--blue)"];

const LocaleNav = ({ heading }) => {
  const { data, loading } = useLocales();

  if (loading || !data) {
    return null;
  }

  return (
    <section className={styles.element} id="locales">
      {heading && <h2 className={styles.heading}>{heading}</h2>}
      <ul className={styles.list}>
        {data.locales.map(({ id, title, uri }, i) => {
          return (
            <li key={id}>
              <Link
                to={`/${uri}`}
                className={styles.link}
                style={{ borderColor: colors[i % colors.length] }}
              >
                {title} <SVG src={arrow} />
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default LocaleNav;
